import { render } from "./TopBar.vue?vue&type=template&id=650dbb68&scoped=true"
import script from "./TopBar.vue?vue&type=script&lang=js"
export * from "./TopBar.vue?vue&type=script&lang=js"

import "./TopBar.vue?vue&type=style&index=0&id=650dbb68&scoped=true&lang=css"
import "./TopBar.vue?vue&type=style&index=1&id=650dbb68&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-650dbb68"]])

export default __exports__